import axios from './rest-axios';

const getConfig = (id) => axios.get(`/manage/config/${id}`);
const putConfig = (id, config) => axios.put(`/manage/config/${id}`, {config: config});

export {
    getConfig,
    putConfig,
};
